import api from './axios';

export const authApi = {
  checkSetup: () => api.get('/auth/setup'),
  login: (login, password) => api.post('/auth/login', { login, password }),
  register: (data) => api.post('/auth/register', data),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
  getMe: () => api.get('/auth/me'),
};
